import request from '@/utils/request'
/** -------------------------*审批中心*-------------------------* */
// 审批列表- 提交审核结果
export function approvalTaskSubmit(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/submit',
    // url: '/admin/v1/vehicle/approvalTask/submit',
    method: 'POST',
    data,
  })
}

/**
 * @apiName 获取审批任务列表
 * @apiUrl
 */
export function getApprovalTaskList(data = {}) {
  return request({
    // url: '/admin/v1/vehicle/approvalTask/getPage',
    url: '/admin/v1/approval/approvalTask/getPage',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 钉钉组织列表
 * @apiUrl
 */
export function getDingtalkOrganizationList(data = {}) {
  return request({
    // url: '/admin/v1/approval/dingtalkOrganization/page',
    url: '/admin/v1/approval/dingtalkOrganization/list',
    method: 'POST',
    data,
  })
}
// 钉钉审批流查看详情
export function detailInfo(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/detailedInfo',
    method: 'POST',
    data,
  })
}

// TODO: 服务端已下线该接口
// 支付宝支付网约钱包支付详情
export function getWithholdApprovalForm(data = {}) {
  return request({
    url: '/admin/v1/vehicle/rent/order/withhold/getApprovalForm',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 审批流配置分页
 * @apiUrl
 */
export function getApprovalTemplateList(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/page',
    method: 'POST',
    data,
  })
}
/**
 * @apiName 起禁用、下放权限
 * @apiUrl
 */
export function updateStatus(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/update',
    method: 'POST',
    data,
  })
}
// 该公司该审批流名称下是否有待审核状态的审批
export function approvalTasktaskGet(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTask/taskGet',
    method: 'POST',
    data,
  })
}


/** 查询所有分组(财务/车辆) */
export function getGroupTypeList(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/groupTypeList',
    method: 'POST',
    data,
  })
}
/** 查询所有查询审批业务类型 */
export function getBizTypeList(data = {}) {
  return request({
    url: '/admin/v1/approval/approvalTemplate/bizTypeList',
    method: 'POST',
    data,
  })
}
/** 查询所有dingding组织 */
export function getOrganizationList(data = {}) {
  return request({
    url: '/admin/v1/approval/flow/getOrganizationList',
    method: 'POST',
    data,
  })
}
/** 查询所有审批人 */
export function getApproverList(data = {}) {
  return request({
    url: '/admin/v1/approval/flow/getApproverList',
    method: 'POST',
    data,
  })
}
/** 查询所有审批人 */
export function submitApprover(data = {}) {
  return request({
    url: '/admin/v1/approval/flow/submit',
    method: 'POST',
    data,
  })
}

/** 查询所有审批人 */
export function checkOpenState(data = {}) {
  return request({
    url: '/admin/v1/approval/flow/checkOpenState',
    method: 'POST',
    data,
  })
}
